import { gql, useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { IsoToDateWithoutTime } from "../../../CommonFunction/IsoDateTime";
import { LoadTable, Loading } from "../../Components";
import HeaderDiv from "../../Components/HeaderDiv/HeaderDiv";
const GetCustomerLogs = gql`
  query EMTLogDetails {
    EMTLogDetails {
      _id
      timestamp
      level
      message
      meta {
        meta
        Method
        createdData
        previousData
        deletedData
        ClientIP
        Status_Code
        User_Agent
        CPU_Usage
        Memory_Usage
        TenantID
        updatedData
        Response_Time
        Origin
        Referrer
      }
    }
  }
`;
const CustomerSideLogs = () => {
  const [loadingState, setLoading] = useState(true);
  const [newdata, setNewData] = useState([]);
  const { loading, data, refetch } = useQuery(GetCustomerLogs, {
    fetchPolicy: "network-only",
  });

  const processedData = data?.EMTLogDetails.map((el) => {
    const newLog = { ...el }; // Clone the log object to avoid mutation
    newLog.meta = el.meta.map((metaItem) => {
      const parsedFields = {};
      const fieldsToParse = [
        "meta",
        "createdData",
        "previousData",
        "deletedData",
        "CPU_Usage",
        "Memory_Usage",
        "updatedData",
      ];

      fieldsToParse.forEach((field) => {
        if (metaItem[field]) {
          parsedFields[field] = JSON.parse(metaItem[field]);
        }
      });
      return { ...metaItem, ...parsedFields };
    });
    return newLog;
  });

  useEffect(() => {
    setLoading(true);
    if (processedData) {
      const arr = processedData.map(({ _id, level, message, timestamp, meta }) => {
        // Destructure the first item in the meta array
        const {
          ClientIP,
          Method,
          TenantID,
          Status_Code,
          CPU_Usage,
          Memory_Usage,
          createdData,
          previousData,
          deletedData,
          updatedData,
        } = meta[0];

        // Destructure nested properties from CPU_Usage and Memory_Usage
        const { cpu, memory, ppid, pid, ctime, elapsed } = CPU_Usage ?? {};
        const { rss, heapTotal, heapUsed, external, arrayBuffers } = Memory_Usage ?? {};
        const createdDataString = JSON.stringify(createdData, null, 2);
        const previousDataString = JSON.stringify(previousData, null, 2);
        const DeletedDataString = JSON.stringify(deletedData, null, 2);
        const updatedDataString = JSON.stringify(updatedData, null, 2);
        return {
          UserName: meta[0]?.meta?.User_Name,
          Date: IsoToDateWithoutTime(timestamp),
          level,
          message,
          ClientIP,
          Method,
          TenantID,
          Status_Code,
          cpu,
          ctime,
          elapsed,
          pid,
          ppid,
          memory,
          rss,
          heapTotal,
          heapUsed,
          external,
          arrayBuffers,
          createdData: createdDataString,
          previousData: previousDataString,
          deletedData: DeletedDataString,
          updatedData: updatedDataString,
          _id,
        };
      });
      setNewData(arr);
    }
    setLoading(false);
  }, [data]);

  useEffect(() => {
    refetch()
      .then((res) => {})
      .catch((err) => console.log(err));
  }, []);
  return (
    <>
      <div>
        <HeaderDiv title="Customer Logs" />
        {loadingState || loading ? (
          <Loading />
        ) : !newdata?.length ? (
          <p className="DataNotAvailable">Data not Available</p>
        ) : (
          <LoadTable title="Customer_Site_Logs" data={newdata} loading={loading} error={false} />
        )}
      </div>
    </>
  );
};

export default CustomerSideLogs;
